<template>
    <section :class="{ 'toasted': state === true }">

        <div class="toast" :class="{ 'success': tipo === 'Success' }">

            <div class="icon">
                <svg v-if="tipo === 'Success'" xmlns="http://www.w3.org/2000/svg" width="72" height="72"
                    viewBox="0 0 72 72" fill="none">
                    <mask id="mask0_825_7448" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="72"
                        height="72">
                        <rect width="72" height="72" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_825_7448)">
                        <path
                            d="M31.8 47.5612L51.969 27.3923L48.8078 24.231L31.8 41.2388L23.25 32.6887L20.0888 35.85L31.8 47.5612ZM15.9233 61.5C14.4077 61.5 13.125 60.975 12.075 59.925C11.025 58.875 10.5 57.5923 10.5 56.0768V15.9233C10.5 14.4077 11.025 13.125 12.075 12.075C13.125 11.025 14.4077 10.5 15.9233 10.5H56.0768C57.5923 10.5 58.875 11.025 59.925 12.075C60.975 13.125 61.5 14.4077 61.5 15.9233V56.0768C61.5 57.5923 60.975 58.875 59.925 59.925C58.875 60.975 57.5923 61.5 56.0768 61.5H15.9233ZM15.9233 57H56.0768C56.3078 57 56.5193 56.9038 56.7113 56.7113C56.9038 56.5193 57 56.3078 57 56.0768V15.9233C57 15.6922 56.9038 15.4807 56.7113 15.2887C56.5193 15.0962 56.3078 15 56.0768 15H15.9233C15.6922 15 15.4808 15.0962 15.2888 15.2887C15.0963 15.4807 15 15.6922 15 15.9233V56.0768C15 56.3078 15.0963 56.5193 15.2888 56.7113C15.4808 56.9038 15.6922 57 15.9233 57Z"
                            fill="#FF29B6" />
                    </g>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <mask id="mask0_1775_14631" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="36" height="36">
                        <rect width="36" height="36" fill="#f54949" />
                    </mask>
                    <g mask="url(#mask0_1775_14631)">
                        <path
                            d="M18 25.5C18.425 25.5 18.7813 25.3563 19.0688 25.0688C19.3563 24.7813 19.5 24.425 19.5 24C19.5 23.575 19.3563 23.2188 19.0688 22.9313C18.7813 22.6438 18.425 22.5 18 22.5C17.575 22.5 17.2188 22.6438 16.9313 22.9313C16.6438 23.2188 16.5 23.575 16.5 24C16.5 24.425 16.6438 24.7813 16.9313 25.0688C17.2188 25.3563 17.575 25.5 18 25.5ZM16.5 19.5H19.5V10.5H16.5V19.5ZM18 33C15.925 33 13.975 32.6062 12.15 31.8187C10.325 31.0312 8.7375 29.9625 7.3875 28.6125C6.0375 27.2625 4.96875 25.675 4.18125 23.85C3.39375 22.025 3 20.075 3 18C3 15.925 3.39375 13.975 4.18125 12.15C4.96875 10.325 6.0375 8.7375 7.3875 7.3875C8.7375 6.0375 10.325 4.96875 12.15 4.18125C13.975 3.39375 15.925 3 18 3C20.075 3 22.025 3.39375 23.85 4.18125C25.675 4.96875 27.2625 6.0375 28.6125 7.3875C29.9625 8.7375 31.0312 10.325 31.8187 12.15C32.6062 13.975 33 15.925 33 18C33 20.075 32.6062 22.025 31.8187 23.85C31.0312 25.675 29.9625 27.2625 28.6125 28.6125C27.2625 29.9625 25.675 31.0312 23.85 31.8187C22.025 32.6062 20.075 33 18 33ZM18 30C21.35 30 24.1875 28.8375 26.5125 26.5125C28.8375 24.1875 30 21.35 30 18C30 14.65 28.8375 11.8125 26.5125 9.4875C24.1875 7.1625 21.35 6 18 6C14.65 6 11.8125 7.1625 9.4875 9.4875C7.1625 11.8125 6 14.65 6 18C6 21.35 7.1625 24.1875 9.4875 26.5125C11.8125 28.8375 14.65 30 18 30Z"
                            fill="#f54949" />
                    </g>
                </svg>
            </div>

            <div class="toastInfo">
                <p>{{ titulo }}</p>
                <span>{{ text }}</span>
            </div>

            <button @click="clearToast()">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M1.68421 12L0 10.3158L4.33083 5.98496L0 1.68421L1.68421 0L6.01504 4.33083L10.3158 0L12 1.68421L7.66917 5.98496L12 10.3158L10.3158 12L6.01504 7.66917L1.68421 12Z"
                        fill="#8C8C8C" />
                </svg>
            </button>

        </div>

    </section>
</template>

<script>

export default {
    props: {
        tipo: {
            type: String,
        },
        titulo: {
            type: String,
        },
        text: {
            type: String,
        },
        state: {
            type: Boolean,
        },
    },
    methods: {
        clearToast() {
            this.state = false;
        },
    }
};

</script>

<style scoped>
.toasted {
    bottom: 0;
}

section {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    position: fixed;
    left: 0;
    bottom: -10vw;
    padding: .694444vw;
    z-index: 99999;
    transition: bottom 500ms ease-in-out;
}

.toast {
    display: flex;
    align-items: center;
    padding: .416667vw .833333vw;
    align-items: center;
    gap: .416667vw;

    border-radius: .416667vw;
    border: .069444vw solid #ED5D8F;
    background: #FFF;
}

.success {
    background-color: #ED5D8F;
}

.success .icon svg {
    filter: brightness(10);
}

.success .toastInfo p {
    color: #fff;
}

.success .toastInfo span {
    color: #fff;
}

.success button svg {
    filter: brightness(10);
}

.icon {
    width: 2.5vw;
    height: 2.5vw;
}

.icon svg {
    width: 2.5vw;
    height: 2.5vw;
}

.toastInfo {
    display: flex;
    flex-direction: column;
    gap: .208333vw;
}


.toastInfo p {
    color: var(--BLACK, #282828);
    font-family: Barlow;
    font-size: 1.041667vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.toastInfo span {
    width: 14.097222vw;
    color: #8A8A8A;
    font-family: Barlow;
    font-size: .833333vw;
    font-style: normal;
    font-weight: 400;
    line-height: 131%;
}

.toast button {
    display: flex;
    width: 1.666667vw;
    height: 1.666667vw;
    justify-content: center;
    align-items: center;
}

.toast button svg {
    width: .833333vw;
    height: .833333vw;
}

@media (max-width: 834px) {
    section {
        bottom: -20vw;

    }

    .toastInfo p {
        font-size: 2.038369vw;

    }

    .toastInfo span {
        width: 24.340528vw;
        font-size: 1.678657vw;

    }

    .toast {
        padding: 1.079137vw 2.158273vw;
        gap: .719424vw;
    }

    .icon {
        width: 4.196643vw;
        height: 4.196643vw;
    }

    .icon svg {
        width: 4.196643vw;
        height: 4.196643vw;
    }

    .toast button {
        width: 3.83693vw;
        height: 3.83693vw;
    }

    .toast button svg {
        width: 1.918465vw;
        height: 1.918465vw;
    }
}

@media (max-width: 530px) {
    section {
        bottom: -25vw;
        padding: 3.864734vw;
    }

    .toast {
        border-radius: 1.449275vw;

    }

    .toastInfo p {
        font-size: 4.106279vw;

    }

    .toastInfo span {
        width: 49.033817vw;
        font-size: 3.381642vw;

    }

    .toast {
        padding: 2.173914vw 4.347825vw;
        gap: 1.449274vw;
    }

    .icon {
        width: 8.454107vw;
        height: 8.454107vw;
    }

    .icon svg {
        width: 8.454107vw;
        height: 8.454107vw;
    }

    .toast button {
        width: 7.729468vw;
        height: 7.729468vw;
    }

    .toast button svg {
        width: 3.864734vw;
        height: 3.864734vw;
    }
}
</style>